import { graphql } from "api/cms-website/generated";

export const TwoColumnListFragment = graphql(/* GraphQL */ `
    fragment TwoColumnListFragment on ComponentComponentsTwoColumnList {
        id
        noMarginBottom
        twoColumnListTitle: title
        subtitle
        withMobileList
        items {
            ...TwoColumnListItemFragment
        }
    }
`);
